import Vue from "vue"
import VueCompositionAPI from "@vue/composition-api"

import App from "./App.vue"
import { createPinia, PiniaVuePlugin } from "pinia"
import VueAxios from "vue-axios"
import axios from "axios"
import BootstrapVue from "bootstrap-vue"
import VueAwesomeSwiper from "vue-awesome-swiper"
import vuetify from "@/plugins/vuetify"
import router from "./router"
import VueMeta from "vue-meta"
import VueSilentbox from "vue-silentbox"
import BackToTop from "vue-backtotop"

Vue.use(VueCompositionAPI)
const pinia = createPinia()

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
axios.defaults.headers = {
  Accept: "application/json",
}
window.EventSys = new Vue()

Vue.use(VueCompositionAPI)
Vue.use(VueAxios, axios)
Vue.use(pinia)
Vue.use(PiniaVuePlugin)
Vue.use(VueSilentbox)
Vue.use(BootstrapVue)
Vue.use(BackToTop)
Vue.use(VueAwesomeSwiper)
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
})
Vue.prototype.$backendPublic = process.env.VUE_APP_BACKEND_BASE_URL

import "../src/assets/css/bootstrap.css"
import "../src/assets/css/bootstrap-vue.css"
import "../src/assets/css/font-awesome.min.css"
import "../src/assets/css/material-design-iconic-font.min.css"
import "../src/assets/css/ionicons.min.css"
import "../src/assets/css/flaticon.min.css"
import "swiper/css/swiper.min.css"
import "../src/assets/css/animate.min.css"
import "../src/assets/scss/style.scss"

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
  pinia,
}).$mount("#app")
